import * as React from "react"
import { DateRangePicker } from 'rsuite'
import { DateRangePickerSeeker } from "ui-seeker/core"
import { formatDate } from "ui-seeker/utils"

import {useContextSelector} from "use-context-selector";
import {AppDatesContext} from "app/providers";


const { beforeToday } = DateRangePicker

export default function CustomDateRangePicker({ max=0, ...props }) {

	const lastDate = useContextSelector(AppDatesContext, ({state}) => state.lastDate)
	const firstDate = useContextSelector(AppDatesContext, ({state}) => state.firstDate)
	const maxDate = Date.parse(formatDate(lastDate, { format: 'yyyy-MM-dd', receivedFormat: 'yyyyMMdd', isString: true }))
	const minDate = firstDate ? Date.parse(formatDate(firstDate, { format: 'yyyy-MM-dd', receivedFormat: 'yyyyMMdd', isString: true })) : null

	// Inside a report execution (firstDate set) the picker spans its stay-date scope, past dates included
	const disabledDate = minDate
		? d => d < minDate || d >= maxDate
		: d => beforeToday()(d) || d >= maxDate

	const myProps = {
		label: null,
		className: `mt-0 ${props.wrapperClassName || ''}`,
		disabledDate,
		...props
	}

    return <DateRangePickerSeeker {...myProps} />
}